// extracted by mini-css-extract-plugin
export var black = "_p-6";
export var brand = "_p-1";
export var ddefault = "_p-0";
export var error = "_p-3";
export var gray = "_p-2";
export var highContrast = "_p-8";
export var outline = "_p-7";
export var success = "_p-5";
export var warning = "_p-4";